module.exports = __webpack_public_path__ + "img/home_mashangjijian.b5e8c13.webp";